import {
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import { FormattedMessage } from "react-intl";

import useCouponEditDialogStyles from "./styles";

export interface CouponEditDialogProps {
  open: boolean;
  onClose: () => void;
  collection?: boolean;
  onSave(event: any);
}

const CouponEditDialog: React.FC<CouponEditDialogProps> = props => {
  const { onSave, open, onClose, collection = false } = props;
  const classes = useCouponEditDialogStyles({});

  const dialogClose = (event: any) => {
    onSave(event);
    onClose();
  };

  let message = {
    title: "Update Coupon?",
    confirm: "Yes"
  };

  if (collection) {
    message = {
      title: "Update Coupon Collection?",
      confirm: "Proceed"
    };
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      classes={{ paper: classes.dialog }}
    >
      <DialogTitle className={classes.title}>
        <IconButton
          onClick={onClose}
          className={classes.closeIcon}
          id="editDialogCloseBtn"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <Typography className={classes.titleText}>{message.title}</Typography>
      </DialogTitle>
      <div className={classes.dialogContent}>
        <div>All changes made previously will be updated.</div>
      </div>
      <div className={classes.buttonContainer}>
        <Button
          className={classes.cancelButton}
          onClick={onClose}
          id="editDialogCancelBtn"
        >
          <FormattedMessage defaultMessage="Cancel" description="cancel" />
        </Button>
        <Button
          className={classes.confirmButton}
          onClick={dialogClose}
          id="editDialogConfirmBtn"
        >
          <Typography className={classes.textConfirm}>
            {message.confirm}
          </Typography>
        </Button>
      </div>
    </Dialog>
  );
};

export default CouponEditDialog;
